import { BASE_API_URL } from 'constants/env'
import { API_METHODS } from 'constants/api-methods'
import { apiHeaders } from 'utils/api-headers'
import { store } from 'index'
import { handleErrors } from 'utils/handle-errors'
import { useQuery } from 'react-query'

interface SandboxMessageCounts {
  total_inbound: number
  total_outbound: number
}

const fetchMessageCounts = async (
  userId: string
): Promise<SandboxMessageCounts> => {
  const queryParams = new URLSearchParams()
  queryParams.append('user_id', userId)
  queryParams.append('time_range', '30d')

  const response = await fetch(
    `${BASE_API_URL}/api/v4/phone_number_service/per_number_metrics?${queryParams.toString()}`,
    {
      method: API_METHODS.GET,
      headers: apiHeaders(store.getState()),
    }
  )
  const handledResponse = handleErrors(response)
  const data = await handledResponse.json()

  return {
    total_inbound: data.total_counts?.total_inbound_messages ?? 0,
    total_outbound: data.total_counts?.total_outbound_messages ?? 0,
  }
}

const useSandboxMessageCounts = (userId: string | null) => {
  return useQuery(
    ['sandbox-message-counts', userId],
    () => fetchMessageCounts(userId!),
    {
      enabled: !!userId,
      refetchOnWindowFocus: false,
      staleTime: 300000, // 5 min cache
    }
  )
}

export default useSandboxMessageCounts
